import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-auction-iframe',
  templateUrl: './auction-iframe.component.html',
  styleUrls: ['./auction-iframe.component.scss']
})
export class AuctionIframeComponent implements OnInit {
  iframeSrc: SafeResourceUrl;
  status: string = 'Ready';

  constructor(private sanitizer: DomSanitizer) { 
    // Default to auction service home
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('/auction-service/');
  }

  ngOnInit(): void {
    this.status = 'Iframe initialized';
  }

  loadAuctions() {
    this.status = 'Loading auctions...';
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('/auction-service/auctions');
  }

  loadShop() {
    this.status = 'Loading shop...';
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('/auction-service/shop');
  }

  loadHome() {
    this.status = 'Loading auction service home...';
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('/auction-service/');
  }
} 